(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

/**
 * File main.js.
 */
(function () {
  document.documentElement.classList.add("js");
  document.documentElement.classList.remove("no-js");
  // @ts-ignore
  if (!!window.MSInputMethodContext && !!document.documentMode) document.documentElement.classList.add("ie11");
  const darkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) {
    document.documentElement.classList.add('user-prefers-reduced-motion');
  }
  // Remove "novalidate" attribute from default output form
  const commentForm = document.getElementById('commentform');
  if (commentForm) commentForm.removeAttribute('novalidate');
  // @ts-ignore
  window.autosize(document.querySelectorAll('textarea'));
  const reviewButtons = document.querySelectorAll('.review__more-button');
  const showFullReview = event => {
    event.target.previousElementSibling.classList.remove('screen-reader-text');
    event.target.previousElementSibling.previousElementSibling.setAttribute('hidden', '');
    event.target.setAttribute('hidden', '');
  };
  for (let i = 0, len = reviewButtons.length; i < len; i++) {
    reviewButtons[i].addEventListener("click", showFullReview, {
      passive: true
    });
  }
})();

},{}]},{},[1])

//# sourceMappingURL=main.js.map
